module.exports = __webpack_public_path__ + "static/img/Cold5f15f9.a87bd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/emoji/Cold5f15f9.png
// module id = YD63
// module chunks = 1